import {API} from "aws-amplify";
import {
    GetResultQuery,
    GetResultQueryVariables,
    OnCalculationFinishedSubscription,
    OnCalculationFinishedSubscriptionVariables
} from "../../API";
import {toast} from "react-toastify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery, GraphQLSubscription} from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import * as subscriptions from "../../graphql/subscriptions";
import {ToastError} from "../../utils/toastUtil";
import {IMatchModel, IPineconeQueryItemResult} from "../../types/pinecone";
import aws_config from "../../modified_aws-export";

interface IQueryItemFromPineconePayload {
    dropFileId: string;
    key: string;
    topK: number;
    filter?: any;
    isUsingAim?: boolean;
    namespace?: string | null;
}

const getQueryResult = (parsedResults: any, startTime: number): IPineconeQueryItemResult => {
    return {
        trackingModel: "AimModelCalculationFinished",
        duration: performance.now() - startTime,
        results: parsedResults.matches as IMatchModel[]
    };
};

const aimModel: string = "aim-600M-2B-imgs";
const vitModel: string = "vit_small_patch16_224";
const aimTaskName = "TecRMIAIMModel";
const vitTaskName = "TecRMI";

export const queryItemFromPinecone = async ({
                                                dropFileId,
                                                key,
                                                topK,
                                                filter = {namespace: {$in: ["OEM", "Single"]}},
                                                isUsingAim,
                                                namespace = null
                                            }: IQueryItemFromPineconePayload): Promise<IPineconeQueryItemResult> => {
    try {
        const startTime = performance.now();
        const pineconeResult = await API.graphql<GraphQLQuery<GetResultQuery>>({
            query: queries.getResult,
            variables: {
                id: dropFileId,
                bucket: aws_config.aws_user_files_s3_bucket,
                key: key,
                top_k: topK,
                filter: JSON.stringify(filter),
                model: isUsingAim ? aimModel : vitModel,
                task_name: isUsingAim ? aimTaskName : vitTaskName,
                namespace: namespace
            } as GetResultQueryVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
        });

        if (!pineconeResult.data || !pineconeResult.data.getResult) {
            return {} as IPineconeQueryItemResult;
        }

        let parsedResults = JSON.parse(pineconeResult.data.getResult || "{}");

        if (parsedResults.status === "Pending") {
            return await subscribeToImageExtraction(parsedResults.id, startTime);
        } else {
            return getQueryResult(parsedResults, startTime);
        }
    } catch (error) {
        console.error(error);
        toast(error instanceof Error ? error.message : "An unknown error occurred", {type: "error"});
    }

    return {} as IPineconeQueryItemResult;
};

const subscribeToImageExtraction = (
    resultId: string,
    startTime: number
): Promise<IPineconeQueryItemResult> => {
    return new Promise((resolve, reject) => {
        const subscription = API.graphql<GraphQLSubscription<OnCalculationFinishedSubscription>>({
            query: subscriptions.onCalculationFinished,
            variables: {id: resultId} as OnCalculationFinishedSubscriptionVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
        }).subscribe({
            next: (event: any) => {
                let pineconeResult = event.value.data?.onCalculationFinished?.results;
                if (pineconeResult) {
                    let pineconeParsedResult = JSON.parse(pineconeResult);
                    if (pineconeParsedResult["Error"]) {
                        ToastError(pineconeParsedResult["Error"]);
                        reject(pineconeParsedResult["Error"]);
                    }
                    resolve(getQueryResult(pineconeParsedResult, startTime));
                }
                subscription.unsubscribe();
            },
            error: (error: any) => {
                console.error("Subscription error:", error);
                subscription.unsubscribe();
                reject(error);
            }
        });
    });
};
